<script lang="ts" setup>
import { computed } from 'vue'
import { useRouter } from 'vue-router/composables'
import { v4 as uuid } from 'uuid'
import ModuleCard from './ModuleCard.vue'
import { useElementClick } from '@/composables/tracks'
import { READER_ROUTE_NAME } from '@/utils/readerRouteName'

interface Props {
  module: any
  config?: any
  cardClass?: string
  headerClass?: string
}

const props = defineProps<Props>()

const { elementClick } = useElementClick()
const router = useRouter()

const books = computed(() => {
  if (props.module?.resourceList?.records?.length > 10)
    return props.module.resourceList.records.slice(0, 10)

  return props.module?.resourceList?.records || []
})

function gotoCollection() {
  elementClick(`seeall_${props.module.id}`)
  router.push({ name: 'collection', params: { columnId: props.module.id } })
}
</script>

<template>
  <ModuleCard
    :title-text="module.showName"
    :action-text-value="config?.texts?.seeAll || 'See All'"
    :card-class="cardClass"
    :header-class="headerClass"
    @action="gotoCollection"
  >
    <div class="mt-12px relative">
      <div class="rr-banner overflow-x-auto no-scrollbar">
        <div class="flex gap-10px min-w-max pr-16px">
          <div v-for="(book, index) in books" :key="index" class="rr-swiper-item" @click="router.push({ name: READER_ROUTE_NAME, params: { contentId: book.id, chapterId: book.firstChapter?.id || '' } })">
            <BizBookCover
              :id="uuid()"
              :src="book.contentCoverUrl || ''"
              :extra="{
                module_name: module.showName,
                module_id: module.id,
                module_type: module.columnType,
                author: book.authorInfo.author,
                ...book,
              }"
              class="rr-swiper-cover rounded-10px"
            />
            <p class="mt-7px text-12px font-medium lh-17px text-n-text-1 line-clamp-2">
              {{ book.contentName }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </ModuleCard>
</template>

<style scoped>
.rr-swiper-item {
  width: calc((100vw - 68px) / 3);
}

.rr-swiper-cover {
  width: 100%;
}

.no-scrollbar {
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.no-scrollbar::-webkit-scrollbar {
  display: none;
}
</style>
